import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import SignUp from '@/components/SignUp';
import Dashboard from '@/components/Dashboard';
import FrontPage from '@/components/FrontPage';
import AccountSettings from '@/components/AccountSettings';
import CompanyProfile from '@/components/CompanyProfile';
import AuthLayout from '@/components/AuthLayout';
import ForgotPassword from '@/components/ForgotPassword';
import ChangePassword from '@/components/ChangePassword';
import Integrations from '@/components/Integrations';

import { isLoggedIn, login } from '@/utils/auth';
import Persona from '@/components/Persona';

import axios from 'axios'


Vue.use(Router);

var router = new Router({
  routes: [
    {
      path: '/',
      component: Dashboard,
      meta: {requiresAuth: true},
      children:[
        {path: '',  component: FrontPage, meta: {requiresAuth: true}, },
        {path: 'settings',  component: AccountSettings, meta: {requiresAuth: true}, },
        {path: 'companyProfile/:id/:name', name:'CompanyProfile', component: CompanyProfile, meta: {requiresAuth: true},},
        {path: 'personas', component:Persona, meta: {requiresAuth: true},},
        {path:'integrations', component:Integrations}
      ],
    },
    {
      path: '/',
      component: AuthLayout,
      meta: {requiresUnauth: true},
      children: [
        {path: '/forgot_password', component: ForgotPassword},
        {path: '/signup', component: SignUp},
        {path: '/login/', component: Login},
        {path: '/change_password', component: ChangePassword},
      ]
    },
  ],
  mode: 'history',
});



router.beforeEach((to, from, next) => {
  if (to.query.login){
    to.query.login = undefined;
    login();
    next(to);
    return;
  }
  
  if(to.matched.some(record => record.meta.requiresUnauth)){
    if(isLoggedIn())
      next('/'); 
    else
      next();
  }

  else if(to.matched.some(record => record.meta.requiresAuth)){
    if(isLoggedIn()){
      next();
    }
    else{
      const path = process.env.API_LOCATION + `/user`;

      axios.get(path)
        .then((res) => {
          var user = {"name": res.data.username, "email": res.data.email};
          localStorage.setItem("user", JSON.stringify(user));
          next();
        })
        .catch((error) => {
          next('/login/');
        });
    }
  }
  else{
    next();
  }
});

export default router;








// WEBPACK FOOTER //
// ./src/router/index.js